import editCoordinators from './edit'
import * as batchOrderCoordinators from './batchOrder'
import * as paymentCoordinators from './payment'

export default Object.freeze({
  ...editCoordinators,
  ...batchOrderCoordinators,
  ...paymentCoordinators,
})
